import client from '../client'

export const createOnboardingTodo = async ({
  onboardingType,
  description,
  originalImageName,
  originalImagePath,
  mergedImageName,
  mergedImagePath,
}) => {
  const { data } = await client.post(
    '/tasks/onboarding',
    {
      task_img: {
        file_name: mergedImageName,
        path: mergedImagePath,
      },
      task_original_img: {
        file_name: originalImageName,
        path: originalImagePath
      },
      description,
      onboarding_type: onboardingType,
    },
  )

  return data
}